module.exports = __webpack_public_path__ + "img/top01.8c1734c6.png";